import $api from "../http";
import {AxiosResponse} from "axios";
export default class AuthService {
    static async login(email, password,token){

        return $api.post("/login" , {email, password,token})
    }
    static async getPassport(){
        return $api.get("/getPassport")
    }
    static async reg(email , login , password,token,promocode,tokenCaptcha){

        return $api.post("/reg" , {email, password , login,token,promocode,"g-recaptcha-response":tokenCaptcha})
    }
    static async logout(){
        return $api.post("/logout")
    }
    static async test(){
        return $api.get("/test")
    }
}